module.exports = "/_next/static/images/icon_plus_4-2a4207e899d1ba235a0c864018138810.svg";